import { DateTime } from 'luxon';

import { SummaryCounter } from '@common/models';

export class HostSummaryCounter
{
    summaryCounters: SummaryCounter<string>[] = [];
}

export class DashHostSummaryCounter extends HostSummaryCounter
{
    public isEmpty: boolean = false;
    public isLoading: boolean = true;
    public isLoaded: boolean = false;
    public isOups: boolean = false;
    public expirationDate?: DateTime;
}
